// extracted by mini-css-extract-plugin
export default {"questionImagesList":"QuestionImagesList_questionImagesList__qeC8n","fullImageIcon":"QuestionImagesList_fullImageIcon__VkaK9"};